/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { PHDocumentController } from "document-model";
import { DocumentEditor } from "../module.js";
import type { DocumentEditorAction, DocumentEditorPHState } from "./types.js";

export const DocumentEditorController = PHDocumentController.forDocumentModel<
  DocumentEditorPHState,
  DocumentEditorAction
>(DocumentEditor);
